import type { ClientGameApiData } from '@client/entity/client-game/data/api-data/client-game.api-data';
import { ClientGame } from '@client/entity/client-game/domain/model/client-game.model';
import type { GameKind } from '@client/entity/game/common/core/domain/constant/game-kind.constant';
import type { ApiDataTransformer } from '@kiplin/web-common/architecture-core';
import { format, isValid, parseISO } from 'date-fns';
import { injectable } from 'inversify';

@injectable()
export class ClientGameApiDataTransformer implements ApiDataTransformer<ClientGameApiData, ClientGame> {
  public mapItems(items: ClientGameApiData[]): ClientGame[] {
    return items.map((game) => this.map(game));
  }

  public map(data: ClientGameApiData): ClientGame {
    return new ClientGame(
      data.id,
      data.title,
      data.type as GameKind,
      data.isInSubscription,
      data.scope,
      data.accessCode,
      this.normalizeDate(data.startDate),
      this.normalizeDate(data.endDate),
    );
  }

  private normalizeDate(value?: string | null): string | null {
    if (!value) {
      return null;
    }

    const parsed = parseISO(value);
    if (!isValid(parsed)) {
      return null;
    }

    return format(parsed, 'yyyy-MM-dd');
  }
}
